<template>
  <div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$wechat.sdk(sdk => sdk.closeWindow());
  }
};
</script>